

import Vue from 'vue'
import VueRouter from 'vue-router'
import mainmap from '../components/mainmap.vue'



Vue.use(VueRouter)

const routes = [
  
  { 
    path: '/:id?', 
    component: mainmap ,
  },
  /*錯誤跳轉回家*/
  {
    path: '*',
    redirect: '/',
  }

]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

/*
router.beforeEach((to, from, next)=>{
  const isLogin = localStorage.getItem('token') == 'ImLogin' ;
  if( isLogin ){
    next();
  } else {
    if( to.path !== '/login')
      next('/login');
    else
      next();
  }
});
*/

export default router
